import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

/**
 * formly wrapper that draws a field group as a captioned form section (KOR-15208, Figma 8280:7627): the caption is a
 * heading, so a screen reader can move between sections, and the group's fields follow it. Layout lives with the form
 * rhythm in styles.scss, since the fields are rendered outside this component's view.
 */
@Component({
  selector: 'app-form-section-wrapper',
  standalone: true,
  template: `
    <section class="form-section" [attr.aria-labelledby]="captionId">
      <h3 class="form-section-caption" [id]="captionId">{{ props.label }}</h3>
      <ng-container #fieldComponent />
    </section>
  `,
})
export class FormSectionWrapperComponent extends FieldWrapper {
  get captionId(): string {
    return `${this.id}-caption`;
  }
}
